
const shipRouter = [
    {
        path:'',
        name:'ship-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/ship/index.vue'),
    }
]
export default shipRouter